module.exports = __webpack_public_path__ + "static/media/Iran.fe32ca29.WebP";